import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import createHocName from '../services/create-hoc-name';

const NAME = 'WithEnvironment';

export default config => WrappedComponent => {
  class WithEnvironment extends Component {
    static displayName = createHocName(NAME, WrappedComponent);

    render() {
      const props = _.mapValues(config, path => _.get(this.context.environment, path));

      return <WrappedComponent {...this.props} {...props}/>;
    }
  }

  WithEnvironment.contextTypes = {
    environment: PropTypes.object.isRequired,
  };

  hoistNonReactStatics(WithEnvironment, WrappedComponent);

  return WithEnvironment;
};



// WEBPACK FOOTER //
// ./app/hoc/with-environment.js